var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSpend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39547",
    "data-name": "Path 39547",
    d: "M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0ZM8.92,8.21a.5.5,0,0,1,0,.71.5.5,0,0,1-.35.15.485.485,0,0,1-.35-.15L6.01,6.71,3.8,8.92a.5.5,0,0,1-.35.15.485.485,0,0,1-.35-.15.5.5,0,0,1,0-.71L5.31,6,3.1,3.79a.5.5,0,0,1,.71-.71L6.02,5.29,8.23,3.08a.5.5,0,1,1,.71.71L6.73,6,8.94,8.21Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSpend);
export default __webpack_public_path__ + "static/media/NoSpend.e2d90484492b5c6f7f132010b64c6c9a.svg";
export { ForwardRef as ReactComponent };